// packages/web/src/utils/onboardingSteps.ts
import { Step, Placement } from 'react-joyride';
import React from 'react';

const profileSaveButtonStep = (placement: Placement): Step => {
  return {
  target: '.profile-card-button',
  content: (
    <div>
      <p>Click here to save your information and run a new scan</p>
    </div>
  ),
  disableBeacon: true,
  placement: placement,
  };
};

export const dashboardTourSteps: Step[] = [
  {
    target: '.dashboard-sidebar',
    content: (
      <div>
        <p>This is your main privacy Dashboard</p>
        <p>Here you can see your exposure stats, removals progress, and opt-out requests.</p>
        <p>Right now we&apos;re running your scan to locate your information. We&apos;ll come back here in a moment to check on your results.</p>
      </div>
    ),
    disableBeacon: true,
    placement: 'right-start',
  },
  {
    target: '.opt-out-requests-tab',
    content: (
      <div>
        <p>Check out the opt-out requests tab</p>
      </div>
    ),
    disableBeacon: true,
    placement: 'bottom',
  },
  {
    target: '.opt-outs-table',
    content: (
      <div>
        <p>Check out the opt-out requests tab</p>
      </div>
    ),
    disableBeacon: true,
    placement: 'top',
  },

];

export const profileTourSteps: Step[] = [
  {
    target: '.profile-sidebar',
    content: (
      <div>
        <p>Let&apos;s finish setting up your profile</p>
        <p>More info means a more complete scan of where your data&apos;s been leaked.</p>
      </div>
    ),
    disableBeacon: true,  
    placement: 'right-start',
  },
  profileSaveButtonStep('bottom'),
  {
    target: '.dashboard-sidebar',
    content: (
      <div>
        <p>Lets head back to the Privacy Dashboard</p>
        <p>Time to check your scan and see where your information is exposed.</p>
      </div>
    ),
    disableBeacon: true,  
    placement: 'right-start',
  },
];

export const subscribedTourSteps: Step[] = [
  {
    target: '.profile-sidebar',
    content: (
      <div>
        <p>New features are now available with your subscription.</p>
        <p>Just a few extra details can provide a full, comprehensive scan of where your data has been leaked across the web.</p>
      </div>
    ),
    disableBeacon: true,
    placement: 'right-start',
  },
  {
    target: '.basic-info-sidebar',
    content: (
      <div>
        <p>Add Additional names and your LinkedIn URL.</p>
        <p>More info means a more complete scan of where your data’s been leaked.</p>
      </div>
    ),
    disableBeacon: true,
    placement: 'left-start',
  },
  {
    target: '.basic-info-linkedin-url',
    content: (
      <div>
        <p>Add your LinkedIn URL</p>
      </div>
    ),
    disableBeacon: true,
    placement: 'left',
  },
  {
    target: '.address-sidebar',
    content: (
      <div>
        <p>Add any extra additional street addresses.</p>
        <p>Past & current street addresses help us find more leaks tied to your identity.</p>
      </div>
    ),
    disableBeacon: true,
    placement: 'left-start',
  },
  {
    target: '.address-sidebar-button',
    content: (
      <div>
        <p>You may add extra addresses here</p>
      </div>
    ),
    disableBeacon: true,
    placement: 'left',
  },
  {
    target: '.phone-email-sidebar',
    content: (
      <div>
        <p>Add your additional email addresses.</p>
        <p>Additional email addresses can uncover data leaks linked to every part of your digital footprint.</p>
      </div>
    ),
    disableBeacon: true,
    placement: 'left-start',
  },
  {
    target: '.phone-email-button',
    content: (
      <div>
        <p>Add Extra Email addresses</p>
      </div>
    ),
    disableBeacon: true,
    placement: 'left',
  },
];

export const InvitedUserTourSteps: Step[] = [
  ...dashboardTourSteps,
  ...subscribedTourSteps,
  profileSaveButtonStep('top'),
];
